var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.8168 76.742L74.3969 63.9134C74.1817 63.4122 73.8017 63.0001 73.3166 62.7484L55.1431 53.3781C54.3923 52.9821 53.4814 53.0324 52.7628 53.5062L40.0005 62.0136L27.2381 53.5062C26.5103 53.021 25.5856 52.9821 24.8211 53.394C24.7113 53.4559 13.4269 59.4708 6.73449 62.7208C6.22638 62.9679 5.82357 63.3937 5.5992 63.9178L0.183956 76.7442C-0.191352 77.6323 0.0191141 78.6599 0.710355 79.3327C1.38894 80.0008 2.41861 80.1905 3.31048 79.7905L23.1182 70.9031L38.8559 79.7013C39.57 80.0996 40.4306 80.0996 41.1447 79.7013L56.8824 70.9031L76.6901 79.7905C77.5735 80.1865 78.6035 80.0057 79.2902 79.3327C79.9815 78.6601 80.1921 77.6323 79.8168 76.742Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0005 0C28.3689 0 18.907 9.4619 18.907 21.0935C18.907 25.4239 20.2117 29.5871 22.679 33.1347L38.078 55.2444C38.5175 55.8738 39.2361 56.2492 40.0006 56.2492C40.7652 56.2492 41.4837 55.8739 41.9233 55.2444L57.3223 33.1347C59.7896 29.5871 61.0943 25.4237 61.0943 21.0935C61.094 9.4619 51.632 0 40.0005 0ZM40.0005 30.4683C34.8324 30.4683 30.6256 26.2639 30.6256 21.0935C30.6256 15.9231 34.8324 11.7186 40.0005 11.7186C45.1685 11.7186 49.3754 15.9231 49.3754 21.0935C49.3754 26.2639 45.1685 30.4683 40.0005 30.4683Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40.0003,
    y1: 80,
    x2: 40.0003,
    y2: 53.1114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3FFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#F0FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 40.0003,
    y1: 56.2492,
    x2: 40.0003,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CFFAC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoMap);
export default __webpack_public_path__ + "static/media/picto_map.c600b59702365fe6337fa564f4a41d8a.svg";
export { ForwardRef as ReactComponent };